<div class="mt--125 block">
  <h3>AutoPay</h3>
  <ng-container *ngIf="(hasError$ | async) === false; else errorState">
    <div class="mt--050">
      Configure automatic payments for a streamlined experience
    </div>

    @if (autopayEligibilityService.hasIneligibleAutopayPayables()) {
      <div class="alert alert--info my-4">
        AutoPay won’t cover every invoice. {{ configService.customerName }} has restricted some types of invoices from automatic payment — those will still need to be paid manually by their due date. Contact your firm for more details.
      </div>
    }

    <div class="data-table__cont mt--125">
      <table
        mat-table
        matSort
        matSortActive="timeFrame"
        [dataSource]="dataSource"
        matSortDirection="asc" class="data-table__tbl"
        data-cy="autopay-table"
      >
        <!--Account Name-->
        <ng-container matColumnDef="account">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Account
          </th>
          <td mat-cell *matCellDef="let autopayDisplay" data-cy="autopay-account">
            {{ autopayDisplay.account }}
          </td>
        </ng-container>

        <!--Enabled-->
        <ng-container matColumnDef="enabled">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            AutoPay enabled
          </th>
          <td mat-cell *matCellDef="let autoPayDisplay" data-cy="autopay-enabled">
            <pill
              [color]="autoPayDisplay.pill.color"
              [value]="autoPayDisplay.pill.value"
              tooltip="AutoPay is not yet supported for clients with a non-USD currency."
              [tooltipEnabled]="autoPayDisplay.isClientNonUsd"
              class="w-fit-content"
            ></pill>
          </td>
        </ng-container>

        <!--Day of month-->
        <ng-container matColumnDef="day">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="day-header">
            AutoPay day of month
          </th>
          <td mat-cell *matCellDef="let autopayDisplay" data-cy="autopay-day" class="day-cell ta--right">
            {{ autopayDisplay.active ? autopayDisplay.day : '- -' }}
          </td>
        </ng-container>

        <!--Method-->
        <ng-container matColumnDef="method">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Method
          </th>
          <td mat-cell *matCellDef="let autopayDisplay" class="tt--capitalize" data-cy="autopay-method">
            <ng-container *ngIf="autopayDisplay.active; else noMethod">
              <!--Renders if payment method is ACH-->
              <span *ngIf="isDirectDebit(autopayDisplay.method.paymentMethod); else card">
              <img
                src="assets/payment-methods/union.svg"
                width="20" height="20" alt="" class="data-table__payment-icon">
                {{ autopayDisplay.method.paymentMethod | uppercase }} Bank Transfer ••••{{autopayDisplay.method.last4}}
            </span>

              <!--Renders if payment method is CREDIT or DEBIT-->
              <ng-template #card>
                <img
                  src="assets/payment-methods/{{autopayDisplay.method.cardType}}.svg"
                  width="20" height="20" alt="" class="data-table__payment-icon">
                {{autopayDisplay.method.cardType}}
                ••••{{autopayDisplay.method.last4}}
              </ng-template>

              <button
                *ngIf="!autopayDisplay.isPaymentMethodFromUser"
                (click)="launchPaymentMethodIsNotFromUserInfoModal()"
              >
                <div class="badge--primary">
                  <svg width="12" height="20" viewBox="0 0 16 16" fill="currentColor" class="inline-icon">
                    <path
                      d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z"></path>
                    <rect x="7" y="7" width="2" height="5"></rect>
                    <circle cx="8" cy="5" r="1"></circle>
                  </svg>
                </div>
              </button>
            </ng-container>
            <ng-template #noMethod>
              - -
            </ng-template>
          </td>
        </ng-container>

        <!--Amount-->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Amount
          </th>
          <td mat-cell *matCellDef="let autopayDisplay" data-cy="autopay-amount">
            <ng-container *ngIf="autopayDisplay.active; else disabledAmount">
              {{ autopayDisplay.amount ? 'Up to ' + formatAmount(autopayDisplay.amount) + '*' : 'Full amount' }}
            </ng-container>
            <ng-template #disabledAmount>
              - -
            </ng-template>
          </td>
        </ng-container>

        <!--Actions-->
        <ng-container matColumnDef="actions" class="width--1">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let autopayDisplay" data-cy="autopay-actions" class="actions-cell">
            <button
              *ngIf="!autopayDisplay.active || autopayDisplay.isClientNonUsd; else editDeleteButtons"
              andButton
              color="hyperlink"
              [disabled]="autopayDisplay.isClientNonUsd"
              class="py-1 ps-1 pe-0 fw-light"
              (click)="addEditAutoPay(autopayDisplay)"
            >
              Set up AutoPay
            </button>

            <ng-template #editDeleteButtons>
              <div>
                <button (click)="addEditAutoPay(autopayDisplay)" type="button" class="button button--text edit-auto">
                  <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="button__icon">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                <button (click)="openDisableDialog(autopayDisplay)" type="button" class="button button--text">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" stroke="transparent"  class="button__icon icon-disable">
                    <g clip-path="url(#clip0_439_18483)">
                      <path d="M4.83162 2.22766C4.95821 2.08299 5.14109 2 5.33333 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V12C16 12.5304 15.7893 13.0391 15.4142 13.4142C15.0391 13.7893 14.5304 14 14 14H5.33333C5.14109 14 4.95821 13.917 4.83162 13.7723L0.164949 8.439C-0.054983 8.18765 -0.054983 7.81235 0.164949 7.561L4.83162 2.22766ZM5.63585 3.33333L1.55251 8L5.63585 12.6667H14C14.1768 12.6667 14.3464 12.5964 14.4714 12.4714C14.5964 12.3464 14.6667 12.1768 14.6667 12V4C14.6667 3.82319 14.5964 3.65362 14.4714 3.5286C14.3464 3.40357 14.1768 3.33333 14 3.33333H5.63585Z"/>
                      <path d="M12.4713 5.52864C12.7317 5.78899 12.7317 6.2111 12.4713 6.47145L8.47132 10.4714C8.21097 10.7318 7.78886 10.7318 7.52851 10.4714C7.26816 10.2111 7.26816 9.78899 7.52851 9.52864L11.5285 5.52864C11.7889 5.26829 12.211 5.26829 12.4713 5.52864Z"/>
                      <path d="M7.52851 5.52864C7.78886 5.26829 8.21097 5.26829 8.47132 5.52864L12.4713 9.52864C12.7317 9.78899 12.7317 10.2111 12.4713 10.4714C12.211 10.7318 11.7889 10.7318 11.5285 10.4714L7.52851 6.47145C7.26816 6.2111 7.26816 5.78899 7.52851 5.52864Z"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_439_18483">
                        <rect width="16" height="16" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="data-table__row"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay" class="data-table__row"></tr>
      </table>
    </div>

    <div class="mt--050 p--xs">
      *If the total amount due exceeds your maximum authorized payment amount, you will still be responsible for making another payment by the due date.
    </div>
  </ng-container>
</div>

<ng-template #errorState>
  <div class="mt--050">Sorry, AutoPay settings are currently unavailable. Please check back again soon.</div>
</ng-template>
